import { Component, Input, OnInit } from '@angular/core';
import { Communication } from 'src/app/models';
@Component({
  selector: 'app-communication-item',
  templateUrl: './communication-item.component.html',
  styleUrls: ['./communication-item.component.scss']
})
export class CommunicationItemComponent implements OnInit {
  @Input() communication: Communication;

  public title: string;
  constructor() {}

  public ngOnInit() {
    if (this.communication.communicationType === 'client_email') {
      const emailCommunicationType: number = this.communication
        .emailCommunicationType;

      if (emailCommunicationType === 1) {
        this.title = 'Appointment Reminder';
      } else if (emailCommunicationType === 2) {
        this.title = 'Appointment Request';
      } else if (emailCommunicationType === 3) {
        this.title = 'Appointment Confirmation';
      } else {
        this.title = 'Appointment Reminder';
      }
    } else if (this.communication.communicationType === 'bulk_email') {
      this.title = this.communication.title;
    } else if (this.communication.communicationType === 'sms') {
      this.title = 'SMS';
    }
  }
}
